import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
    Col,
    Row,
    FormCheckbox,
    FormGroup,
    Popover,
    PopoverBody
} from "shards-react";
import ScopeService from "../../../../services/scope-service/ScopeService";
import axios from "axios";
import { GenericAlert } from "../../../alert/GenericAlert";

export default function UserPermissionsCardComponent(props) {
    const { permissions, handleUserSwitchChange, title, disabled } = props;

    const initialStatusAlert = {
        theme: "",
        message: "",
        isOpen: false
    };

    const [statusAlert, setStatusAlert] = useState(initialStatusAlert);
    const [opennedDescription, setOpennedDescription] = useState(null);
    const [scopes, setScopes] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    const getScopes = async () => {
        try {
            setIsFetching(true);
            const result = await ScopeService.findAll();
            setScopes(result);
            setIsFetching(false);
        } catch (error) {
            setIsFetching(false);
            if (axios.isAxiosError(error)) {
                setStatusAlert({
                    message:
                        error.response?.data?.message ||
                        "Houve um erro ao listar os escopos",
                    theme: "danger",
                    isOpen: true
                });
                return;
            }
            setStatusAlert({
                message:
                    "Houve um erro inesperado ao listar os escopos, tente novamente",
                theme: "danger",
                isOpen: true
            });
        }
    };
    useEffect(() => {
        getScopes();
    }, []);

    const toggle = description => {
        if (description === opennedDescription) setOpennedDescription(null);
        else setOpennedDescription(description);
    };

    const verifyChecked = scopeName => {
        return (
            permissions.includes(scopeName) ||
            permissions.includes(scopeName.toUpperCase())
        );
    };

    const closeAlert = () => {
        setStatusAlert(initialStatusAlert);
    };

    return (
        <React.Fragment>
            <GenericAlert
                className="mb-3 cypreGenericAlert"
                dismissible={() => closeAlert()}
                open={statusAlert.isOpen}
                theme={statusAlert.theme}
            >
                {statusAlert.message}
            </GenericAlert>
            {isFetching ? (
                <div className="loading--container">
                    <div className="lds-dual-ring"></div>
                    <h1 className="loading--text">Carregando...</h1>
                </div>
            ) : (
                <>
                    <Row>
                        <Col style={{ fontWeight: "600" }}>{title}</Col>
                    </Row>
                    &nbsp;
                    <Row>
                        {scopes.map((scope, permissionKey) => {
                            const isChecked = verifyChecked(scope.name);

                            return (
                                <Col
                                    className="col-sm-12 col-md-6 col-lg-4 col-xl-3"
                                    key={permissionKey}
                                >
                                    <FormGroup className="d-flex align-items-start">
                                        <FormCheckbox
                                            disabled={disabled}
                                            key={permissionKey}
                                            inline
                                            checked={isChecked}
                                            name={scope.name}
                                            value={scope.name}
                                            onChange={() =>
                                                handleUserSwitchChange(
                                                    scope.name
                                                )
                                            }
                                        >
                                            {scope.name}
                                        </FormCheckbox>
                                        <i
                                            style={{ cursor: "pointer" }}
                                            className="material-icons"
                                            id={`permission-description-${permissionKey}`}
                                            onClick={() =>
                                                toggle(
                                                    `permission-description-${permissionKey}`
                                                )
                                            }
                                        >
                                            help
                                        </i>
                                    </FormGroup>
                                    <Popover
                                        placement="bottom"
                                        open={
                                            opennedDescription &&
                                            opennedDescription ===
                                                `permission-description-${permissionKey}`
                                        }
                                        toggle={value => toggle(value)}
                                        target={`#permission-description-${permissionKey}`}
                                    >
                                        <PopoverBody>
                                            {scope.description}
                                        </PopoverBody>
                                    </Popover>
                                </Col>
                            );
                        })}
                        <hr />
                    </Row>
                </>
            )}
        </React.Fragment>
    );
}

UserPermissionsCardComponent.propTypes = {
    permissions: PropTypes.array,
    context: PropTypes.object,
    handleUserSwitchChange: PropTypes.func,
    title: PropTypes.string,
    disabled: PropTypes.bool
};
